/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import {useTranslation} from 'react-i18next'
import UiBadgeGroup from 'components/Ui/UiBadgeGroup'
import {OfferStatus} from 'types/enums/OfferStatus'
import {useOfferStatusOptions} from 'hooks/enums/useOfferStatusOptions'
import clsx from 'clsx'


interface UiOfferStatusBadgeGroupProps {
    value: OfferStatus | null
    onChange: (value: OfferStatus | null) => void
    disabled?: boolean
    className?: string
}

const UiOfferStatusBadgeGroup: React.FC<UiOfferStatusBadgeGroupProps> = ({
    value,
    onChange,
    disabled,
    className,
}) => {
    const { t } = useTranslation()
    const { options } = useOfferStatusOptions()

    const badgeItems = options.map((opt) => ({
        id: opt.value,
        label: opt.label,
    }))

    return (
        <div className={clsx('UiOfferStatusBadgeGroup flex flex-row items-center gap-4', className)}>
            <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {t('Offer status')}
            </div>
            <UiBadgeGroup
                items={badgeItems}
                value={value}
                onChange={(val) => onChange(val as OfferStatus)}
                disabled={disabled}
                disabledItemIds={
                    value === OfferStatus.Accepted ? [] : [OfferStatus.Accepted]
                }
            />
        </div>
    )
}

export default UiOfferStatusBadgeGroup
